var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9173 7.6312L18.8986 1.3148C18.4927 0.515624 17.681 0 16.7931 0H5.20029C4.31235 0 3.50069 0.515578 3.09481 1.34067L0.101392 7.65707L0 7.76012V13.5867C0 15.1851 1.29368 16.5 2.86654 16.5H19.1269C20.6996 16.5 21.9934 15.1852 21.9934 13.5867L21.9933 7.96637C22.0186 7.83742 21.9681 7.70852 21.9173 7.6312ZM4.4901 2.01089C4.61697 1.753 4.89601 1.57263 5.20038 1.57263H16.7678C17.0722 1.57263 17.3767 1.75319 17.5034 2.0366L19.9893 7.27019H14.0285C13.5973 7.27019 13.2674 7.6054 13.2674 8.04367C13.2674 9.307 12.2528 10.3382 11.0097 10.3382C9.76665 10.3382 8.75206 9.30704 8.75206 8.04367C8.75206 7.60542 8.42223 7.27019 7.991 7.27019H2.00434L4.4901 2.01089Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarInbox);
export default __webpack_public_path__ + "static/media/tabbar_inbox.2c2622e017fd595b4f787044efc88731.svg";
export { ForwardRef as ReactComponent };